import { getStoryblokImageUrl } from "../../../helpers/images/getStoryblokImageUrl";
import { CosmosText } from "@cosmos/web-react";
import classnames from "classnames/bind";
import Link from "next/link";
import styles from "./NavigationCardShort.module.css";

const cx = classnames.bind(styles);

export const NavigationCardShort = ({
  label,
  iconSrc,
  selected,
  // dragProgress = 0,
  onClick,
  href,
}: {
  label: string;
  iconSrc: string;
  selected?: boolean;
  // dragProgress?: number;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  href?: string;
}) => {
  const cardContent = (
    <div className={cx("card")} data-selected={selected}>
      <div className={cx("body")}>
        <div className={cx("content")}>
          <CosmosText
            className={cx("text")}
            appearance="dark"
            kind="subtle"
            size="x-small"
            tag="span"
            weight="medium"
            clamp={1}
          >
            {label}
          </CosmosText>
        </div>
        <img
          srcSet={[1, 1.5, 2]
            .map((dpiMultiplier) => dpiMultiplier * 24)
            .map(Math.ceil)
            .map((size) => {
              const src = getStoryblokImageUrl(iconSrc, {
                width: size,
                height: size,
              });

              return `${src} ${size}w`;
            })
            .join(", ")}
          sizes="24px"
          src={getStoryblokImageUrl(iconSrc)}
          alt=""
          className={cx("icon")}
        />
      </div>
    </div>
  );

  if (href) {
    return (
      <Link
        href={href}
        className={cx("container")}
        onClick={onClick}

        // style={
        //   {
        //     "--fade-opacity-inverted": isNaN(dragProgress)
        //       ? 1
        //       : 1 - dragProgress,
        //   } as React.CSSProperties
        // }
        // TODO: aria-label: something like "Filter options by {interestGroup.title}"
      >
        {cardContent}
      </Link>
    );
  }

  return (
    <div
      className={cx("container")}

      // style={
      //   {
      //     "--fade-opacity": isNaN(dragProgress) ? 0 : dragProgress,
      //   } as React.CSSProperties
      // }
    >
      {cardContent}
    </div>
  );
};
